<template>
  <div>
    <template v-if="width < 2054 && width > 1699">
      <vs-row justify="flex-end">
        <vs-col :key="index" v-for="(col, index) in 3" w="2"><br/></vs-col>
      </vs-row>
    </template>
    <vx-card title="관리자관리 - 전체">
      <div class="vx-row mb-3">
        <div class="vx-col w-full">
          <ul>
            <li>Lv1 : 환자 등록과 수정은 가능하나 삭제는 불가능, 스케줄 열람 가능</li>
            <li>Lv2 : 병원관리를 제외한 모든 기능 가능</li>
            <li>Lv3 : 병원관리를 포함한 모든 기능 가능 , 슈퍼관리자</li>
          </ul>
        </div>
      </div>
      <div class="flex justify-end flex-wrap">
        <vs-chip color="primary">
          <vs-avatar color="primary" icon-pack="feather" icon="icon-edit-2" @click="openPopupFun(9999)"/>
          <span>+ 관리자등록</span>
        </vs-chip>
      </div>
      <div class="vx-row mb-3">
        <div class="vx-col w-full">
          <vs-input class=" w-auto" icon="search" placeholder="검색내용을 입력해주세요." v-model="search" @keyup.enter="adminList"/>
        </div>
      </div>
      <vs-table :max-items="cutPage" :data="list" :noDataText="'데이터가 존재하지 않습니다.'">
        <template slot="thead">
          <vs-th class="table_header" width="10%">관리자 이름</vs-th>
          <vs-th class="table_header" width="10%">관리자 ID</vs-th>
          <vs-th class="table_header" width="10%">관리자 PW</vs-th>
          <vs-th class="table_header" width="10%">레벨</vs-th>
          <vs-th class="table_header" width="10%">원장님</vs-th>
          <vs-th class="table_header" width="10%">진료과목</vs-th>
          <vs-th class="table_header" width="10%">상태</vs-th>
          <!-- <vs-th class="table_header" width="15%">IP권한</vs-th> -->
          <vs-th class="table_header" width="*">관리</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr v-for="(tr, index) in data" :key="index">
            <vs-td>{{ tr.USERNAME }}</vs-td>
            <vs-td>{{ tr.USERID }}</vs-td>
            <vs-td>{{ tr.USERPWD }}</vs-td>
            <vs-td>{{ tr.LEVEL_TEXT }}</vs-td>
            <!-- <vs-td>
                <div class="vx-row mt-2">
                    <div class="vx-col w-full">
                        <vs-radio type="radio" :vs-name="'JOIN_IP_' + tr.UID" v-model="tr.JOIN_IP" :vs-value="'Y'" v-on:change="ipUpdate(tr)"> 특정아이피 허용</vs-radio>
                    </div>
                    <div class="vx-col w-full">
                        <vs-radio type="radio" :vs-name="'JOIN_IP_' + tr.UID" v-model="tr.JOIN_IP" :vs-value="'N'" v-on:change="ipUpdate(tr)"> 모든 아이피 허용</vs-radio>
                    </div>
                </div>
            </vs-td> -->
            <vs-td>
              <template v-if="tr.DOCTOR_TYPE == 'W'">양방</template>
              <template v-if="tr.DOCTOR_TYPE == 'E'">한방</template>
            </vs-td>
            <vs-td>{{ tr.DOCTOR_MEMO }}</vs-td>
            <vs-td>
              <template v-if="tr.STATUS == 'Y'">활성화</template>
              <template v-else><span style="color:#f1f1f1;">비활성화</span></template>
            </vs-td>
            <vs-td>
              <!-- <vs-chip color="warning">
                  <vs-avatar color="primary" icon-pack="feather" icon="icon-edit-2" @click="ipShow(tr)" />
                  <span>아이피등록</span>
              </vs-chip> -->
              <vs-chip color="primary">
                <vs-avatar color="primary" icon-pack="feather" icon="icon-edit-2" @click="openPopupFun(index)"/>
                <span>수정</span>
              </vs-chip>
              <vs-chip color="danger">
                <vs-avatar color="danger" icon-pack="feather" icon="icon-x" @click="removeadminConfirm(index)"/>
                <span>삭제</span>
              </vs-chip>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <br/>
      <vs-pagination :total="pageCount" v-model="curPage" @input="adminList" :max="7"></vs-pagination>
    </vx-card>

    <vs-popup title="아이피등록 및 수정" :active.sync="ipPopup" id="ip_popup">
      <!-- <vs-chip color="primary">
          <vs-avatar color="primary" icon-pack="feather" icon="icon-edit-2" @click="ipAdd" />
          <span>+ 아이피 등록</span>
      </vs-chip>
      <table id="list" width="100%" class="border-collapse">
          <colgroup>
              <col width="60%" />
              <col width="40%" />
          </colgroup>
          <thead>
              <tr>
                  <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">아이피</th>
                  <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">관리</th>
              </tr>
          </thead>
          <tbody>
              <template v-if="ipList.length == 0">
                  <tr>
                      <td class="border border-solid d-theme-border-grey-light text-center" colspan="2">등록된 아이피가 존재하지 않습니다.</td>
                  </tr>
              </template>
              <template v-else>
                  <tr v-for="(item, index) in ipList" :key="index">
                      <td class="border border-solid d-theme-border-grey-light text-center p-2">
                          <vs-input class="w-full" name="" v-model="item.IP_ADDR" placeholder="IP를 입력해주세요." :value="item.IP_ADDR" />
                      </td>
                      <td class="border border-solid d-theme-border-grey-light text-center p-2">
                          <template v-if="item.SEQ == -1">
                              <vs-button color="primary" class="mr-3" @click="ipAddSave(index)">등록</vs-button>
                          </template>
                          <template v-else>
                              <vs-button color="primary" class="mr-3" @click="ipAddSave(index)">수정</vs-button>
                              <vs-button color="danger" class="mr-3" @click="ipDelete(item.SEQ)">삭제</vs-button>
                          </template>
                      </td>
                  </tr>
              </template>
          </tbody>
      </table> -->
    </vs-popup>
    <vs-popup title="관리자 등록 및 수정" :active.sync="openPopup" id="admin_popup">
      <form>
        <input type="hidden" v-model="uid"/>
        <div class="flex justify-end flex-wrap">
          <vs-checkbox v-model="status">
            계정비활성화
          </vs-checkbox>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vs-input class="w-full" name="" label="관리자명" placeholder="관리자명을 입력해주세요." v-model="userName" ref="userName"/>
            <span class="text-danger text-sm" v-if="flag1">관리자명을 입력해주세요.</span>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vs-input class="w-full" name="" label="관리자 아이디" placeholder="관리자 ID 입력해주세요." v-model="userID" ref="userID" :disabled="uid != '0'"/>
            <span class="text-danger text-sm" v-if="flag2">관리자 ID 입력해주세요.</span>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vs-input class="w-full" type="password" name="" label="관리자 비밀번호" placeholder="관리자 비밀번호를 입력해주세요." v-model="userPWD" ref="userPWD"/>
            <span class="text-danger text-sm" v-if="flag3">관리자 비밀번호를 입력해주세요.</span>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vs-select
                autocomplete
                @input-change="autoCompleteFunc"
                class="w-full"
                label="관리자 권한(Level)"
                v-model="userLevel"
                name="userLevel"
                placeholder="관리자 권한을 선택해주세요."
                ref="userLevel"
            >
              <vs-select-item :value="''" :text="'관리자 권한을 선택해주세요.'"/>
              <vs-select-item v-for="(item, index) in level_list" :value="item.CD_LEVEL" :text="item.LEVEL_TEXT + ' (' + item.LEVEL_NM + ')'"
                              :key="index"/>
            </vs-select>
            <span class="text-danger text-sm" v-if="flag4">관리자 권한을 선택해주세요. </span>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vs-select
                autocomplete
                @input-change="autoCompleteFunc"
                class="w-full"
                label="팀"
                v-model="team"
                name="team"
                placeholder="팀을 선택해주세요."
                ref="team"
            >
              <vs-select-item :value="''" :text="'팀을 선택해주세요.'"/>
              <vs-select-item v-for="(item, index) in team_list" :value="item.TEAM_CODE" :text="item.TEAM" />
            </vs-select>
            <span class="text-danger text-sm" v-if="flag5">팀을 선택해주세요. </span>
          </div>
        </div>
        <div class="vx-row mb-6" v-if="department_list.filter(i => i.TEAM_CODE === team).length > 0">
          <div class="vx-col w-full">
            <vs-select
                autocomplete
                @input-change="autoCompleteFunc"
                class="w-full"
                label="세부소속"
                v-model="department"
                name="department"
                placeholder="세부소속을 선택해주세요."
                ref="department"
            >
              <vs-select-item :value="''" :text="'세부소속을 선택해주세요.'"/>
              <vs-select-item v-for="(item, index) in department_list.filter(i => i.TEAM_CODE === team)" :value="item.DEPARTMENT_CODE" :text="item.DEPARTMENT" />
            </vs-select>
            <span class="text-danger text-sm" v-if="flag6">세부소속을 선택해주세요. </span>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vs-select
                autocomplete
                @input-change="autoCompleteFunc"
                class="w-full"
                label="직함"
                v-model="position"
                name="position"
                placeholder="직함을 선택해주세요."
                ref="position"
            >
              <vs-select-item :value="''" :text="'직함을 선택해주세요.'"/>
              <vs-select-item v-for="(item, index) in position_list" :value="item.POSITION_CODE" :text="item.POSITION" />
            </vs-select>
            <span class="text-danger text-sm" v-if="flag7">직함을 선택해주세요. </span>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vs-input class="w-full" name="" label="휴대폰번호" placeholder="휴대폰번호 입력해주세요." v-model="phone" ref="phone" />
<!--            <span class="text-danger text-sm">휴대폰번호 입력해주세요.</span>-->
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vs-input class="w-full" name="" label="070번호" placeholder="070번호 입력해주세요." v-model="phone070" ref="phone070" />
<!--            <span class="text-danger text-sm">070번호 입력해주세요.</span>-->
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vs-input class="w-full" name="" label="내선번호" placeholder="내선번호 입력해주세요." v-model="phoneExtension" ref="phoneExtension" />
<!--            <span class="text-danger text-sm">내선번호 입력해주세요.</span>-->
          </div>
        </div>
        <vs-divider color="danger">설정</vs-divider>
        <div class="vx-row mb-3">
          <div class="vx-col w-full lg:w-1/1 justify-between">
            <vs-checkbox v-model="dc">
              원장님이면 선택해주세요.
            </vs-checkbox>
            <template v-if="this.dc == true">
              <div class="vx-col w-full">
                <vs-select
                    autocomplete
                    @input-change="autoCompleteFunc"
                    class="w-full"
                    label="원장님 세부정보"
                    v-model="dc_type"
                    name="dc_type"
                    placeholder="구분을 선택해주세요."
                    ref="dc_type"
                >
                  <vs-select-item :value="'W'" :text="'양방'"/>
                  <vs-select-item :value="'E'" :text="'한방'"/>
                </vs-select>
                <span class="text-danger text-sm" v-if="flag4">관리자 권한을 선택해주세요. </span>
              </div>
              <vs-input v-model="dc_memo" placeholder="진료과목" class="mt-1 w-full"/>
            </template>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vs-select
                autocomplete
                @input-change="autoCompleteFunc"
                class="w-full"
                label="관리자 권한(Level)"
                v-model="userLevel"
                name="userLevel"
                placeholder="관리자 권한을 선택해주세요."
                ref="userLevel"
            >
              <vs-select-item :value="''" :text="'관리자 권한을 선택해주세요.'"/>
              <vs-select-item v-for="(item, index) in level_list" :value="item.CD_LEVEL" :text="item.LEVEL_TEXT + ' (' + item.LEVEL_NM + ')'"
                              :key="index"/>
            </vs-select>
            <span class="text-danger text-sm" v-if="flag4">관리자 권한을 선택해주세요. </span>
          </div>
        </div>
        <vx-card ref="" title="치료실" class="user-list-filters mb-6 collapsed" collapseAction :isCollapsed="false">
          <div class="vx-row">
            <div class="vx-col w-1/3" v-for="(item, index) in tablist_01" :key="index">
              <vs-checkbox type="checkbox" :vs-value="item.TAB_CODE" v-model="tabArray_01" :id="'tab_01_' + index"> {{
                  item.MEDICAL_NM
                }}
              </vs-checkbox>
            </div>
          </div>
        </vx-card>
        <vx-card ref="" title="외래치료실" class="user-list-filters mb-6 collapsed" collapseAction :isCollapsed="false">
          <div class="vx-row">
            <div class="vx-col w-1/3" v-for="(item, index) in tablist_03" :key="index">
              <vs-checkbox type="checkbox" :vs-value="item.TAB_CODE" v-model="tabArray_03" :id="'tab_03_' + index"> {{
                  item.MEDICAL_NM
                }}
              </vs-checkbox>
            </div>
          </div>
        </vx-card>
        <vx-card ref="" title="탭설정" class="user-list-filters mb-6 collapsed" collapseAction :isCollapsed="false">
          <div class="vx-row">
            <div class="vx-col w-1/3" v-for="(item, index) in tablist" :key="index">
              <vs-checkbox type="checkbox" :vs-value="item.TAB_CODE" v-model="tabArray" :id="'tab_' + index"> {{ item.TAB_NAME }}</vs-checkbox>
            </div>
          </div>
        </vx-card>
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <vs-select autocomplete @input-change="autoCompleteFunc" class="w-full" label="아이피 권한" v-model="ip_yn" name="ip_yn"
                       placeholder="아이피권한을 선택해주세요." ref="ip_yn">
              <vs-select-item :value="'N'" :text="'모든 아이피 허용'"/>
              <vs-select-item :value="'Y'" :text="'특정 아이피 허용'"/>
            </vs-select>
            <span class="text-danger text-sm" v-if="flag4">관리자 권한을 선택해주세요. </span>
          </div>
        </div>
        <vx-card ref="" title="아이피 리스트" class="user-list-filters mb-6 collapsed" collapseAction :isCollapsed="false">
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-chip color="primary">
                <vs-avatar color="primary" icon-pack="feather" icon="icon-edit-2" @click="ipAdd"/>
                <span>+ 아이피 등록</span>
              </vs-chip>
              <table id="list" width="100%" class="border-collapse">
                <colgroup>
                  <col width="60%"/>
                  <col width="40%"/>
                </colgroup>
                <thead>
                <tr>
                  <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">아이피</th>
                  <th class="p-2 border border-solid d-theme-border-grey-light text-center table_header">관리</th>
                </tr>
                </thead>
                <tbody>
                <template v-if="ipList.length == 0">
                  <tr>
                    <td class="border border-solid d-theme-border-grey-light text-center" colspan="2">등록된 아이피가 존재하지 않습니다.</td>
                  </tr>
                </template>
                <template v-else>
                  <tr v-for="(item, index) in ipList" :key="index">
                    <td class="border border-solid d-theme-border-grey-light text-center p-2">
                      <vs-input class="w-full" name="" v-model="item.IP_ADDR" placeholder="IP를 입력해주세요." :value="item.IP_ADDR"/>
                    </td>
                    <td class="border border-solid d-theme-border-grey-light text-center p-2">
                      <template v-if="item.SEQ == -1">
                        <vs-button color="primary" class="mr-3" @click="ipAddSave(index)">등록</vs-button>
                      </template>
                      <template v-else>
                        <vs-button color="primary" class="mr-3" @click="ipAddSave(index)">수정</vs-button>
                        <vs-button color="danger" class="mr-3" @click="ipDelete(item.SEQ)">삭제</vs-button>
                      </template>
                    </td>
                  </tr>
                </template>
                </tbody>
              </table>
            </div>
          </div>
        </vx-card>
        <div class="vx-row">
          <div class="vx-col w-full text-right">
            <vs-button class="mr-3 mb-2" @click="save">저장</vs-button>
            <vs-button color="warning" type="border" class="mb-2" @click="openPopup = false">닫기</vs-button>
          </div>
        </div>
      </form>
    </vs-popup>
  </div>
</template>

<script>
import axiosClass from '@/../util/axiosClass';
import store from '../../store/store';
import VueCookies from 'vue-cookies';

export default {
  data() {
    return {
      phone: '',
      phone070: '',
      phoneExtension: '',
      team: 0,
      position: 0,
      department: 0,
      search: '',
      curPage: 1,
      cutPage: 10,
      list: [],
      tablist: [],
      pageCount: 0,
      openPopup: false,
      ipPopup: false,
      ipList: [],
      ipWrite: false,
      selectedItem: {},
      userName: '',
      userID: '',
      userPWD: '',
      userLevel: '',
      flag1: false,
      flag2: false,
      flag3: false,
      flag4: false,
      flag5: false,
      flag6: false,
      flag7: false,
      uid: '',
      ip_yn: 'Y',
      level: '',
      loginUid: '',
      level_list: [],
      team_list: [],
      department_list: [],
      position_list: [],
      tabArray: [],

      tablist_01: [],
      tabArray_01: [],

      tablist_03: [],
      tabArray_03: [],
      dc: '',
      dc_memo: '',
      dc_type: '',
      status: '',
      width: window.innerWidth,
    };
  },
  methods: {
    handleResize(event) {
      this.width = window.innerWidth;
    },
    init() {
      //this.adminList();
    },
    async adminList() {
      let sendData = {
        curPage: this.curPage,
        cutPage: this.cutPage,
        search: this.search,
        level: this.level,
        uid: this.loginUid,
      };
      const {data} = await axiosClass.get('/api/management/adminList', sendData, true);
      console.log('data:::', data);
      if (data.list[0].MSG) {
        const MSG = data.list[0].MSG;
        let err_msg = '';
        if (MSG == 'ERR_ACCESS') {
          err_msg = '접근 권한이 없습니다.';
        } else if (MSG == 'ERR_MEMBER') {
          err_msg = '존재하지 않는 유저입니다.';
        }
      } else {
        this.list = data.list;
        const maxPage = Math.ceil(data.list[0].ALL_COUNT / this.cutPage);
        this.pageCount = maxPage < 1 ? 1 : maxPage;

        // console.log(maxPage);
      }
      this.level_list = data.level_list;
      this.team_list = data.team_list;
      this.department_list = data.department_list;
      this.position_list = data.position_list;
      this.tablist = data.tab_list;
      this.tablist_onoff = data.tab_list_onoff;

      this.tablist_01 = data.tab_list_01;

      this.tablist_03 = data.tab_list_03;
    },
    async openPopupFun(index = 9999) {
      console.log(this.dc);
      this.flag1 = false;
      this.flag2 = false;
      this.flag3 = false;
      this.flag4 = false;
      this.ipList = [];
      if (index == 9999) {
        this.uid = '0';
        this.userName = '';
        this.userID = '';
        this.userPWD = '';
        this.userLevel = '';
        this.ip_yn = 'Y';
        this.dc = '';
        this.dc_memo = '';
        this.dc_type = '';
        this.tabArray = [];
        this.tabArray_01 = [];
        this.tabArray_03 = [];
      } else {
        // console.log('checkpopup');
        const item = this.list[index];

        const {data} = await axiosClass.get('/api/management/adminIpList/' + item.UID, {}, true);
        // console.log(item.UID);
        this.ipList = data.list;

        this.uid = item.UID;
        this.userName = item.USERNAME;
        this.userID = item.USERID;
        this.userPWD = item.USERPWD;
        this.userLevel = item.CD_LEVEL;
        this.ip_yn = item.JOIN_IP;
        this.team = item.CD_TEAM || 0;
        this.department = item.CD_DEPARTMENT || 0;
        this.position = item.CD_POSITION || 0;
        this.phone = item.PHONE;
        this.phone070 = item.PHONE_070;
        this.phoneExtension = item.PHONE_EXTENSION;

        // console.log(item.TAB_SUM);
        // console.log('-----');
        this.tabArray = [];
        this.tabArray_01 = [];
        this.tabArray_03 = [];

        if (item.DOCTOR_YN == 'Y') {
          this.dc = true;
        } else {
          this.dc = false;
        }
        this.dc_type = item.DOCTOR_TYPE;
        this.dc_memo = item.DOCTOR_MEMO;

        if (item.STATUS == 'Y') {
          this.status = false;
        } else {
          this.status = true;
        }
        for (let i = 0; i < this.tablist.length; i++) {
          if ((item.TAB_SUM & this.tablist[i].TAB_CODE) != false) {
            this.tabArray.push(this.tablist[i].TAB_CODE);
          }
        }
        for (let i = 0; i < this.tablist_01.length; i++) {
          if ((item.TAB_SUM_01 & this.tablist_01[i].TAB_CODE) != false) {
            this.tabArray_01.push(this.tablist_01[i].TAB_CODE);
          }
        }
        for (let i = 0; i < this.tablist_03.length; i++) {
          if ((item.TAB_SUM_03 & this.tablist_03[i].TAB_CODE) != false) {
            this.tabArray_03.push(this.tablist_03[i].TAB_CODE);
          }
        }
        // console.log('this.tabArray:::', this.tabArray);
        // console.log('this.tabArray_01:::', this.tabArray_01);
        // console.log('this.tabArray_03:::', this.tabArray_03);
      }
      this.openPopup = true;
    },
    //삭제 확인
    removeadminConfirm(index) {
      const userId = this.list[index].USERNAME;
      this.uid = this.list[index].UID;
      let _this = this;
      _this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '삭제',
        text: '해당 관리자(' + userId + ')를 정말로 삭제하시겠습니까? 병동에 배정되어있는 담당자 데이터까지 전부 삭제됩니다.',
        acceptText: '삭제',
        cancelText: '취소',
        accept: _this.removeAdmin,
      });
    },
    async removeAdmin() {
      let sendData = {
        loginUid: this.loginUid,
        uid: this.uid,
      };
      try {
        const {data} = await axiosClass.delete('/api/management/medicalMember', sendData, true);
        if (data.result.MSG == 'OK') {
          this.$vs.notify({
            color: 'primary',
            title: '삭제완료',
            text: '관리자이 삭제되었습니다.',
            position: 'top-right',
            iconPack: 'feather',
          });
          this.adminList();
        } else if (data.result.MSG == 'ERR_ACCESS') {
          this.$vs.notify({
            color: 'danger',
            title: 'error',
            text: '접근 권한이 없습니다.',
            position: 'top-right',
            iconPack: 'feather',
          });
        }
      } catch (e) {
        console.log(e);
      }
    },

    async ipShow(item) {
      this.selectedItem = item;
      console.log(this.selectedItem);
      this.ipWrite = false;
      this.ipPopup = true;
      const {data} = await axiosClass.get('/api/management/adminIpList/' + item.UID, {}, true);
      this.ipList = data.list;
    },

    async ipAdd() {
      if (this.ipWrite == false) {
        this.ipList.push({
          SEQ: -1,
          UID: this.selectedItem.UID,
          IP_ADDR: '',
        });
        this.ipWrite = true;
      } else {
      }
    },

    async ipDelete(seq) {
      const sendData = {
        seq: seq,
      };
      const {data} = await axiosClass.delete('/api/management/adminIpList/' + this.uid, sendData, true);
      this.ipList = data.list;
    },

    async ipAddSave(index) {
      const sendData = {
        seq: this.ipList[index].SEQ,
        uid: this.ipList[index].UID,
        ip_addr: this.ipList[index].IP_ADDR,
      };

      const {data} = await axiosClass.post('/api/management/adminIpList/' + this.uid, sendData, true);
      this.ipList = data.list;
      this.ipWrite = false;
    },

    async ipUpdate(item) {
      const sendData = {
        ip_yn: item.JOIN_IP,
      };
      const {data} = await axiosClass.put('/api/management/adminIpUpdate/' + item.UID, sendData, true);

      this.$vs.notify({
        color: 'primary',
        title: '저장',
        text: '저장되었습니다.',
        position: 'top-right',
        iconPack: 'feather',
      });
    },

    async autoCompleteFunc() {
      return;
    },
    //관리자 추가 및 수정
    async save() {
      let color = 'primary';
      let title = '저장완료';
      let msg = '';

      if (this.userName.trim() == '') {
        this.flag1 = true;
        return;
      } else if (this.userID.trim() == '') {
        this.flag2 = true;
        return;
      } else if (this.userPWD.trim() == '') {
        this.flag3 = true;
        return;
      } else if (this.userLevel == '') {
        this.flag4 = true;
        return;
      }

      // tab selected
      const result = this.tabArray.reduce(function add(sum, currValue) {
        return sum + currValue;
      }, 0);

      const tabSum_01 = this.tabArray_01.reduce(function add(sum, currValue) {
        return sum + currValue;
      }, 0);
      const tabSum_03 = this.tabArray_03.reduce(function add(sum, currValue) {
        return sum + currValue;
      }, 0);

      let dcString = '';
      if (this.dc == false) {
        dcString = 'N';
      } else {
        dcString = 'Y';
      }

      let statusString = '';
      if (this.status == false) {
        statusString = 'Y';
      } else {
        statusString = 'N';
      }

      if (result == 0) {
        this.$vs.notify({
          color: 'danger',
          title: '경고',
          text: '적어도 하나의 탭 설정은 하셔야 합니다.',
          position: 'top-right',
          iconPack: 'feather',
        });
        return;
      }
      let sendData = {
        loginUid: this.loginUid,
        uid: this.uid,
        userName: this.userName,
        userID: this.userID,
        userPWD: this.userPWD,
        userLevel: this.userLevel,
        team: this.team,
        department: this.department,
        position: this.position,
        phone: this.phone,
        phone070: this.phone070,
        phoneExtension: this.phoneExtension,
        tabSum: result,
        tabSum_01: tabSum_01,
        tabSum_03: tabSum_03,
        ip_yn: this.ip_yn,
        dc: dcString,
        dc_memo: this.dc_memo,
        dc_type: this.dc_type,
        status: statusString,
      };
      console.log('sendData:::', sendData);
      const {data} = await axiosClass.post('/api/management/adminSave', sendData, true);
      // console.log('----- 수정전 -----');
      // console.log('store.getters.getUSERNAME:::', store.getters.getUSERNAME);
      // console.log('store.getters.getCDLEVEL:::', store.getters.getCDLEVEL);
      // console.log('store.getters.getTABSUM:::', store.getters.getTABSUM);

      if (data.result.MSG == 'ERR_ACCESS') {
        color = 'danger';
        title = '저장실패';
        msg = '접근 권한이 없습니다. 관리자 에게 문의바랍니다.';
      } else if (data.result.MSG == 'OVERLAP_ID') {
        color = 'danger';
        title = '저장실패';
        msg = '이미 아이디가 존재합니다.';
      } else if (data.result.MSG == 'OK') {
        color = 'primary';
        title = '저장완료';
        msg = '관리자 계정이 저장되었습니다.';
        // 20210607 홍현표 추가
        // store.commit('setUSERNAME', '');
        // store.commit('setCDLEVEL', '');
        // store.commit('setTABSUM', '');
        // VueCookies.remove('username');
        // VueCookies.remove('cd_level');
        // VueCookies.remove('tab_sum');

        // store.commit('setUSERNAME', String(this.userName));
        // store.commit('setCDLEVEL', String(this.userLevel));
        // store.commit('setTABSUM', String(result));
        // await VueCookies.set('username', String(this.userName), 0);
        // await VueCookies.set('cd_level', String(this.userLevel), 0);
        // await VueCookies.set('tab_sum', String(result), 0);

        // console.log('----- 수정후 -----');
        // console.log('store.getters.getUSERNAME:::', store.getters.getUSERNAME);
        // console.log('store.getters.getCDLEVEL:::', store.getters.getCDLEVEL);
        // console.log('store.getters.getTABSUM:::', store.getters.getTABSUM);

        this.adminList();
        this.openPopup = false;
      }
      this.$vs.notify({
        color: color,
        title: title,
        text: msg,
        position: 'top-right',
        iconPack: 'feather',
      });
    },
  },

  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.level = store.getters.getCDLEVEL;
    this.loginUid = store.getters.getUID;
    this.init();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style>
.vx-card__title h4 {
  font-size: 15px;
}

#admin_popup .vx-card__header {
  padding: 10px 20px 0px 20px;
}

#admin_popup .vx-card__body {
  padding: 10px;
}

#admin_popup .vx-card__body .checkbox_x {
  margin: 2px;
}
</style>
